import { DataGridColSettings } from '@/components/DataGrid/utils';

export const cfsHistoryDataGridCols: DataGridColSettings[] = [
  {
    field: 'number',
    headerName: 'CFS ID',
    width: 130,
    visible: true,
  },
  {
    field: 'incidentCodes',
    headerName: 'Incident Code',
    width: 200,
    visible: true,
  },
  {
    field: 'createdAt',
    headerName: 'Date and Time',
    width: 180,
    visible: true,
  },
  {
    field: 'shortDescription',
    headerName: 'Description',
    width: 300,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 120,
    visible: true,
  },
];
